<template>
	<v-card flat hover  width="175" v-on:click.stop="getCatalogItemDetail">
		<v-card-title>
			<v-avatar size="125" class="mx-auto">
				<v-img position="center center" :src="catalogItem.imageUrl ? catalogItem.imageUrl : '@/assets/imgnotfound.jpg'"
					width="100" height="100">					
				</v-img>
			</v-avatar>
		</v-card-title>
		<v-card-subtitle class="text-subtitle-2 text-center truncate-subtitle">
			{{ catalogItem.itemName }}
		</v-card-subtitle>
	</v-card>
</template>
<script>
export default {
	name: "CatalogItemCard",
	props: {
		catalogItem: Object,
	},
	methods: {
		getCatalogItemDetail() {
			this.$router.push({
				name: "CatalogItem",
				params: { id: Number(this.catalogItem.itemId) },
			});
		},
	},
};
</script>
<style scoped>
.truncate-subtitle {
  /* Set height for 3 lines and enable truncation */
  height: 4.2em;
  line-height: 1.4em;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-word;
}
</style>
